// import React from "react";
// // import LaxButton from "../Shared/LaxButton";
// import { Link } from 'react-router-dom';
// import { HashLink } from 'react-router-hash-link';



// class About extends React.Component {
//   render() {
//     return (
//       <section id="about" className="about-area-three ptb-120 bg-image">
//         <div className="container">
//           <div className="row h-100 align-items-center">
//             <div className="col-lg-6">
//               <div className="about-image">
//                 <img
//                   src={require("../../assets/images/logo.png")}
//                   className="about-img1"
//                   alt="about"
//                 />
//                 {/* <LaxButton /> */}
//               </div>
//             </div>

//             <div className="col-lg-6">
//               <div className="about-content">
//                 <span>Join The Event</span>

//                 <h2>
//                 About RID 3131
//                 </h2>
//                 {/* <h6>
//                   We Work With Organisations To Craft Immersive Customer
//                   Experiences.
//                 </h6> */}
//                 <p>
//                   Rotaract District 3131 emerged at the beginning of Rotary
//                   International Year (abbreviated as RIY) 2008 - 09 when RID
//                   3130 was bifurcated into two separate districts. Upon the
//                   formation of district, the Rotary and Rotaract organization
//                   was given the charge of areas under Raigad and Pune districts.
//                   Presently, there are 138+ Rotaract clubs with more than 2900+
//                   Rotaractors functioning cooperatively for the Rotaract
//                   Movement in RID 3131. Rotaract District 3131 has previously
//                   hosted various international events successfully and now
//                   eagerly wants to host all District leaders at Pune.
//                 </p>

//                 {/* <ul>
//                   <li>
//                     <i className="icofont-long-arrow-right"></i>
//                     Curabitur blandit tempus porttitor.
//                   </li>
//                   <li>
//                     <i className="icofont-long-arrow-right"></i>
//                     Maecenas sed diam eget risus varius blandit sit amet non
//                     magna.
//                   </li>
//                   <li>
//                     <i className="icofont-long-arrow-right"></i>
//                     Fusce dapibus, tellus ac cursus commodo, tortor mauris.
//                   </li>
//                   <li>
//                     <i className="icofont-long-arrow-right"></i>
//                     Condimentum nibh, ut fermentum massa justo sit amet risus
//                     nibh.
//                   </li>
//                 </ul> */}
//                 <div className="d-flex justify-content-between align-items-center mt-3">
//                   <div className="signature" style={{ marginTop: '0px !important'}} >
//                     <img style={{width:"120px"}}
//                       src={require("../../assets/images/Rotaract Logo.png")}
//                       alt="about"
//                     />
//                   </div>
//                   <HashLink style={{ height: '50px' }}smooth  to="/#register"  className="btn btn-primary">Register Now</HashLink >
//                 </div>
                
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   }
// }

// export default About;
import React from 'react';
import lax from 'lax.js';
import LaxButton from '../Shared/LaxButton';
 
class About extends React.Component {

    constructor(props) {
        super(props)
        lax.setup()
    
        document.addEventListener('scroll', function(x) {
            lax.update(window.scrollY)
        }, false)
    
        lax.update(window.scrollY)
    }

    render(){
        return (
            <section id='about-us' className="about-area-two  bg-image">
                <div className="container">
               
                    <div className="row h-100 align-items-center">
                        <div className="col-lg-6">
                            <div className="about-content">
                                <span>Your Event Architects</span>
                                <h2>Crafting Memories, One Experience at a Time</h2>
                                <p>At Nexus Events, we specialise in turning your dreams into reality. Whether it's a dazzling New Year party, a relaxing travel escape, or a bespoke event, we combine creativity, passion, and precision to deliver unforgettable experiences. With a proven track record and a team dedicated to excellence, we’re here to make every moment extraordinary.
                                </p>
                                
                                {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p> */}

                                {/* <div className="signature">
                                    <img src={require("../../assets/images/signature.png")} alt="about" />
                                </div> */}
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="about-image">
                                <img src={require("../../assets/images/Nexus.png")} className="about-img1" alt="about" />

                                {/* <LaxButton /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default About;